<template>
  <checkboxComponent :disabled="disabled" :checked="checked" />
</template>
<script type="text/javascript">
import Vue from "vue";
import checkboxComponent from "../../checkbox/checkboxComponent.vue";
export default Vue.extend({
  components: {
    checkboxComponent: checkboxComponent
  },
  computed: {
    checked: {
      // getter
      get: function() {
        if (this.params.value) {
          return this.params.value;
        } else return false;
      },
      // setter
      set: function(newValue) {
        this.params.value = newValue;
      }
    },
    disabled: {
      // getter
      get: function() {
        if (this.params.rowStartEditing) {
          return false;
        } else return true;
      }
    }
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {}
});
</script>
